import styled from "styled-components";
import {BoardSearchResult} from "../../assets/GlobalStyles";

export const ReportPage = styled.div`
  display:flex;width:100%;flex-direction:column;gap:16px;
`;
export const ReportCard = styled.section`
  position:relative;z-index:${({$condition})=>$condition?10:1};
  overflow:${({$condition})=>$condition?'visible':'hidden'};
  border:1px solid #e1e6eb;border-radius:10px;background:var(--color-surface);
  box-shadow:0 5px 18px rgba(31,41,55,.045);
`;
export const SectionHeader = styled.div`
  display:flex;min-height:68px;align-items:center;justify-content:space-between;gap:18px;
  padding:12px 16px;border-bottom:1px solid #e9edf1;background:#fbfcfe;
  border-radius:${({$clickable,$open})=>$clickable?($open?'10px 10px 0 0':'10px'):'10px 10px 0 0'};
  cursor:${({$clickable})=>$clickable?'pointer':'default'};transition:background .15s ease;
  ${({$clickable})=>$clickable&&'&:hover{background:#f7faff;}'}
  &:focus-visible{outline:2px solid var(--color-primary-focus);outline-offset:-2px;}
  @media(max-width:900px){align-items:flex-start;flex-direction:column;}
`;
export const SectionHeading = styled.div`
  display:flex;min-width:0;align-items:center;gap:10px;
  strong,span{display:block;}strong{color:var(--color-text-strong);font-size: var(--font-size-15);font-weight:750;}
  span{margin-top:4px;color:var(--color-text-muted);font-size: var(--font-size-12);}
`;
export const SectionAccent = styled.i`
  width:3px;height:32px;flex:0 0 3px;border-radius:3px;background:var(--color-primary);
`;
export const HeaderRight = styled.div`
  display:flex;min-width:0;align-items:center;justify-content:flex-end;gap:8px;
  @media(max-width:900px){width:100%;justify-content:space-between;}
`;
export const ConditionSummary = styled.div`
  display:flex;min-width:0;align-items:center;justify-content:flex-end;gap:6px;flex-wrap:wrap;
`;
export const SummaryChip = styled.span`
  display:inline-flex;height:28px;align-items:center;gap:5px;padding:0 9px;
  border:1px solid #dbe7f5;border-radius:999px;background:var(--color-surface-muted);color:#84909c;font-size: var(--font-size-11);white-space:nowrap;
  b{max-width:180px;overflow:hidden;color:var(--color-primary-strong);font-size: var(--font-size-11);text-overflow:ellipsis;}
`;
export const CollapseIcon = styled.span`
  display:inline-flex;width:18px;height:28px;flex:0 0 18px;align-items:center;justify-content:center;
  transform:rotate(${({$open})=>$open?'180deg':'0deg'});transition:transform .18s ease;
  &::before{width:0;height:0;border-top:5px solid var(--color-primary);border-right:4px solid transparent;border-left:4px solid transparent;content:'';}
`;
export const ConditionBody = styled.div`
  padding:4px 0 0;border-radius:0 0 10px 10px;background:var(--color-surface);
  >div{margin:0;padding:16px 18px 18px;background:var(--color-surface);}
  [class*="-control"]{min-height:38px;border-color:var(--color-border-strong);border-radius:7px;box-shadow:none;}
  input{font-size: var(--font-size-13);}
`;
export const TableBody = styled.div`
  padding:10px 12px 14px;
  ${BoardSearchResult}{margin:0;padding:0;background:var(--color-surface);}
  .InovuaReactDataGrid--theme-default-light{overflow:hidden;border:1px solid var(--color-border-strong);border-radius:8px;font-size: var(--font-size-13);}
  .InovuaReactDataGrid__header,.InovuaReactDataGrid__column-header{border-color:#cddff5 !important;background:#f2f7fd;}
  .InovuaReactDataGrid__header{border-bottom:2px solid #8bb8ea !important;}
`;
export const ExcelHeaderButton = styled.button`
  display:inline-flex;min-width:88px;height:34px;align-items:center;justify-content:center;padding:0 12px;
  border:1px solid #d7e5d9;border-radius:6px;background:#f7fbf7;color:#47774d;font-size: var(--font-size-12);font-weight:700;cursor:pointer;
  &:hover{border-color:#bcd6c0;background:#eef7ef;}
`;
